<template>
  <a-modal title="兑换配置"
           :width="660"
           :open="modal"
           :confirloading="loading"
           :mask-closable="false"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">

    <div v-for="(v, i) in conf" :key="i">
      <a-space class="dvd">
        <span>兑换物品ID</span>
        <a-input-number size="small" v-model:value="v.id" min="1"/>

        <span>消耗</span>
        <a-input-number size="small" v-model:value="v.cost" min="1"/>

        <a-button type="primary" size="small" @click="addRewardCk(i)">添加奖品</a-button>
        <a-button danger size="small" @click="delOutCk(i)">-</a-button>
      </a-space>

      <div v-for="(v0, i0) in v.v" :key="i0" class="dvd">
        <a-space>
          <a-select class="fix-w" :options="typeList" size="small" v-model:value="v0.type"/>

          <span>数量</span>
          <a-input-number class="fix-w" size="small" v-model:value="v0.num" min="0"/>

          <span>奖品ID</span>
          <a-input class="fix-w" size="small" v-model:value="v0.id"/>

          <span>名称</span>
          <a-input class="fix-w" size="small" v-model:value="v0.name" :maxlength="20"/>

          <a-button danger size="small" @click="delRewardCk(i, i0)">-</a-button>
        </a-space>
      </div>

      <a-divider/>
    </div>

    <a-button size="small" type="primary" @click="addOutCk">添加兑换物品</a-button>

  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message, Modal} from 'ant-design-vue'

const modal = ref(false)
const loading = ref(false)

const conf = ref({})

const typeList = [
  {label: "优惠券", value: 0},
  {label: "虚拟道具", value: 1},
]

function openCk() {
  axios.get('/config/ex_res').then((res) => {
    if (res.code === 1) {
      conf.value = res.data
    }
    modal.value = true
  })
}

function addOutCk() {
  conf.value.push({
    id: 0,
    cost: 0,
    v: [{type: 0, num: 1, id: 0, name: ''}]
  })
}

function delOutCk(idx) {
  Modal.confirm({
    content: '确定删除吗',
    okText: '确定',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      conf.value.splice(idx, 1)
    },
  })
}

function addRewardCk(idx) {
  conf.value[idx].v.push({type: 0, num: 1, id: ''})
}

function delRewardCk(gIdx, rIdx) {
  Modal.confirm({
    content: '确定删除吗',
    okText: '确定',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      conf.value[gIdx].v.splice(rIdx, 1)
    },
  })
}

function okCk() {
  loading.value = true
  axios.post('/config/ex_res', {
    v: conf.value,
    c: 1,
  }).then((res) => {
    if (res.code === 1) {
      message.success('操作成功')
    }
    modal.value = false
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

defineExpose({openCk})
</script>

<style scoped>
.dvd {
  margin-bottom: 5px;
}

.dvd:last-child {
  margin-bottom: 0;
}

.fix-w {
  width: 100px;
}
</style>
